import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";

export default class FieldList extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let _this = this;
    let fields = document.querySelectorAll('.preview-field-list__field');
    for (let i = 0; i < fields.length; i++) {
      fields[i].addEventListener('dragstart', function (e) {

        let fieldIndex = $(this).attr("data-index");
        _this.props.dataset.persistenceId = _this.props.dataset.datasetId;
        let data = {
          dataset: _this.props.dataset,
          field: _this.props.fields[fieldIndex],
          value: _this.props.fields[fieldIndex].name,
          isPreviewWidget: true
        };
        e.dataTransfer.setData("text/plain", data.dataset.name.replace(/([\+\-\*\/])/g, "_") + " " + data.field.name);
        e.dataTransfer.setData("data", JSON.stringify(data));
        _this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START);
        setTimeout(function () {
          $(".legend-config-wrapper").css("z-index", 101);
          $("div[name='legendContainer']").css("z-index", 101);
          $("div[name='legends']").css("z-index", 101);
        }, 200);
      }, false);

      fields[i].addEventListener('dragend', (e) => {
        $(".legend-config-wrapper").css("z-index", "");
        $("div[name='legendContainer']").css("z-index", "");
        $(".add-widget-legends").css("z-index", "");
        this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END);
      }, false);
    }
  }

  render() {
    let fields = [];
    for (let i = 0; i < this.props.fields.length; i++) {
      if (this.props.fields[i].name != null) {
        fields.push(
          <div className="preview-field-list__field" key={i} draggable="true" data-index={i}>
            <span>{this.props.fields[i].name}</span>
          </div>
        );
      }
    }

    return (
      <div className="preview-field-list">
        <div className="preview-field-list__title">Drag & Drop Fields</div>
        {fields}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/fieldList.jsx